import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import FeaturedWorks from './components/FeaturedWorks';
import Ranking from './components/Ranking';
import Categories from './components/Categories';
import LatestUpdates from './components/LatestUpdates';
import Guides from './components/Guides';
import Faq from './components/Faq';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Features />
        <FeaturedWorks />
        <Ranking />
        <Categories />
        <LatestUpdates />
        <Guides />
        <Faq />
        <About />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}